export default "/images/custom_development/custom_development__hero_image.png";